import { TrevareFestMapWrapper } from 'components/eventView/pages/MapWrappers/TrevareFestMapWrapper';

export const TrevareFestivalPage = (): JSX.Element => {
    return <TrevareFestMapWrapper mapId={'051fb270-76a3-4a89-a03d-c0fb17135e53'} />;
};
